import React from "react";
import { toast } from "sonner";
import { DownloadSimple } from "@phosphor-icons/react";
import { usePortalAuth, formatPortalError } from "../../lib/portal-auth-context";
import {
  DataTable,
  PageHeader,
  StatusPill,
  formatDate,
  formatMXN,
  useFetchList,
} from "./portal-ui";

const PdfButton = ({ invoice, api }) => {
  const download = async () => {
    try {
      const res = await api.get(`/invoices/${invoice.id}/pdf`, {
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ICOR-${invoice.folio || invoice.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(
        formatPortalError(err.response?.data?.detail) || err.message
      );
    }
  };
  return (
    <button
      onClick={download}
      data-testid={`portal-invoice-pdf-${invoice.id}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--icor-blue)] hover:underline"
    >
      <DownloadSimple size={14} weight="bold" /> Descargar
    </button>
  );
};

export default function PortalInvoices() {
  const { api } = usePortalAuth();
  const { items, loading } = useFetchList(api, "/invoices");

  return (
    <div data-testid="portal-invoices-page">
      <PageHeader
        eyebrow="Facturación"
        title="Mis facturas"
        subtitle="Facturas CFDI 4.0 emitidas a tu cuenta. Descarga la representación impresa en PDF."
      />
      <DataTable
        testId="portal-invoices-table"
        loading={loading}
        rows={items}
        emptyMsg="Aún no tienes facturas emitidas."
        columns={[
          { key: "folio", label: "Folio", render: (r) => r.folio || "—" },
          { key: "issued_at", label: "Emitida", render: (r) => formatDate(r.issued_at) },
          { key: "due_at", label: "Vencimiento", render: (r) => formatDate(r.due_at) },
          { key: "amount", label: "Monto", render: (r) => formatMXN(r.amount) },
          { key: "status", label: "Estado", render: (r) => <StatusPill value={r.status} /> },
          { key: "pdf", label: "PDF", render: (r) => <PdfButton invoice={r} api={api} /> },
        ]}
      />
    </div>
  );
}
